import * as R from 'ramda';

export default function IncompleteAssessmentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  orgDataService,
  bcpDataService,
  loaderService,
  addAssessmentDialog,
  bcpBoardApproveDialog,
  bcpEditAssessmentDocumentDialog,
  confirmDialog,
  generateFullReportDialog,
  ssDialogService,
  userService
) {
  const vm = this;

  vm.isExpanded = false;
  vm.handleExpandAssessment = _handleExpandAssessment;
  vm.handleEditAssessment = _handleEditAssessment;

  vm.handleDelete = _handleDelete;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  vm.handleAttachDocument = _handleAttachDocument;
  vm.handleDownloadAllDocuments = _handleDownloadAllDocuments;

  vm.handleGenerateReport = _handleGenerateReport;
  vm.handleBoardApprove = _handleBoardApprove;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();

    _initEventListeners();
    _initPermissions();
    _initStatuses(vm.assessment.status);

    dfdActivate.resolve();
  }

  function _initPermissions() {
    vm.canExpand = true;
    vm.canApprove = vm.canEdit && vm.assessment.canBoardApprove;
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
      vm.permissions.canApproveAssessment = vm.assessment.canBoardApprove;
      vm.permissions.canAttachDocuments = vm.assessment.canAttachDocuments;
    });
  }

  function _initEventListeners() {
    $scope.$on('setDocumentRegenerateFlag', _setDocumentRegenerateFlag);
    $scope.$on('refreshStatusesComplete', (event, status) => {
      _initStatuses(status);
    });
    $scope.$on('refreshOtherResourcesStatus', (event, opt) => {
      vm.assessment.status.otherResourcesStatus = opt.status;
      _initStatuses(vm.assessment.status);
    });
    $scope.$on('refreshBCPAssessmentDocuments', (event, opt) => {
      if (opt.assessmentId === vm.assessment.assessmentId) {
        _refreshAssessmentDocuments();
      }
    });
  }

  /*
    TODO: Put this and the identical _initStatuses function from risk-management.controller.js into the same
    function call
  */

  function _initStatuses(status) {
    vm.assessment.status = status;

    // Risk/Threat Assessment
    let enterpriseThreatAssessmentStatus = '';
    if (vm.assessment.status.enterpriseThreatAssessmentStatus === 'Enterprise Threat Assessment Complete') {
      enterpriseThreatAssessmentStatus = 'complete';
    } else if (
      vm.assessment.status.enterpriseThreatAssessmentStatus !== 'Enterprise Threat Assessment Complete'
      && vm.assessment.status.enterpriseThreatAssessmentStatus !== 'Enterprise Threat Assessment Not Started'
    ) {
      enterpriseThreatAssessmentStatus = 'in progress';
    } else {
      enterpriseThreatAssessmentStatus = 'not started';
    }

    let topThreatsByProcessStatus = '';
    if (vm.assessment.status.topThreatsByProcessStatus === 'Top Threats by Process Assessment Complete') {
      topThreatsByProcessStatus = 'complete';
    } else if (
      vm.assessment.status.topThreatsByProcessStatus !== 'Top Threats by Process Assessment Complete'
      && vm.assessment.status.topThreatsByProcessStatus !== 'No Process Threats Assessed'
    ) {
      topThreatsByProcessStatus = 'in progress';
    } else {
      topThreatsByProcessStatus = 'not started';
    }

    if (enterpriseThreatAssessmentStatus === 'complete' && topThreatsByProcessStatus === 'complete') {
      vm.riskThreatAssessmentStatus = 'complete';
    } else if (enterpriseThreatAssessmentStatus === 'not started' && topThreatsByProcessStatus === 'not started') {
      vm.riskThreatAssessmentStatus = 'not started';
    } else {
      vm.riskThreatAssessmentStatus = 'in progress';
    }
    vm.riskThreatAssessmentStatusText = `${vm.assessment.status.enterpriseThreatAssessmentStatus}<br>
      ${vm.assessment.status.topThreatsByProcessStatus}`;


    // Risk Management
    let departmentProceduresStatus = '';
    if (vm.assessment.status.departmentProceduresStatus !== 'No Recovery Procedures Set') {
      departmentProceduresStatus = 'complete';
    } else {
      departmentProceduresStatus = 'not started';
    }

    let departmentResourceStatus = '';
    if (vm.assessment.status.departmentResourceStatus === 'Department Resources Complete') {
      departmentResourceStatus = 'complete';
    } else if (
      vm.assessment.status.departmentResourceStatus !== 'Department Resources Complete'
      && vm.assessment.status.departmentResourceStatus !== 'No Department Resources Added'
    ) {
      departmentResourceStatus = 'in progress';
    } else {
      departmentResourceStatus = 'not started';
    }

    let facilitiesStatus = '';
    if (vm.assessment.status.facilitiesStatus === 'Facilities Info Complete') {
      facilitiesStatus = 'complete';
    } else {
      facilitiesStatus = 'not started';
    }

    let itCoreProceduresStatus = '';
    if (vm.assessment.status.itCoreProceduresStatus === 'IT/Core Procedures Complete') {
      itCoreProceduresStatus = 'complete';
    } else if (
      vm.assessment.status.itCoreProceduresStatus !== 'IT/Core Procedures Complete'
      && vm.assessment.status.itCoreProceduresStatus !== '0/3 IT/Core Procedures Complete'
    ) {
      itCoreProceduresStatus = 'in progress';
    } else {
      itCoreProceduresStatus = 'not started';
    }

    let schematicStatus = '';
    if (vm.assessment.status.schematicStatus !== '0 Schematics Added') {
      schematicStatus = 'complete';
    } else {
      schematicStatus = 'not started';
    }

    let workstationStatus = '';
    if (vm.assessment.status.workstationStatus !== '0 WorkStations Added') {
      workstationStatus = 'complete';
    } else {
      workstationStatus = 'not started';
    }

    let serverStatus = '';
    if (vm.assessment.status.serverStatus !== '0 Servers Added') {
      serverStatus = 'complete';
    } else {
      serverStatus = 'not started';
    }

    let emergencyPlansStatus = '';
    if (vm.assessment.status.emergencyPlansStatus !== 'Emergency Plans Complete') {
      const emergencyPlansStatusArray = vm.assessment.status.emergencyPlansStatus.split('/');
      vm.completedEmergencyPlansCount = parseInt(emergencyPlansStatusArray[0], 10);
      if (vm.completedEmergencyPlansCount === 0) {
        emergencyPlansStatus = 'not started';
      } else {
        emergencyPlansStatus = 'in progress';
      }
    } else {
      emergencyPlansStatus = 'complete';
    }

    let pandemicPlansStatus = '';
    if (vm.assessment.status.pandemicPlansStatus === 'Pandemic Plans Complete') {
      pandemicPlansStatus = 'complete';
    } else {
      pandemicPlansStatus = 'not started';
    }

    let successionPlanningStatus = '';
    if (vm.assessment.status.successionPlanningStatus !== 'Succession Planning Complete') {
      const successionPlanningStatusArray = vm.assessment.status.successionPlanningStatus.split('/');
      const completedSuccessionPlanningCount = parseInt(successionPlanningStatusArray[0], 10);
      if (completedSuccessionPlanningCount === 0) {
        successionPlanningStatus = 'not started';
      } else {
        successionPlanningStatus = 'in progress';
      }
    } else {
      successionPlanningStatus = 'complete';
    }


    let healthResourceStatus = '';
    if (vm.assessment.status.healthResourceStatus !== 'No Health Resources Added') {
      healthResourceStatus = 'complete';
    } else {
      healthResourceStatus = 'not started';
    }

    let vendorResourcesStatus = '';
    if (vm.assessment.status.vendorResourcesStatus !== 'No Vendor Resources Added') {
      vendorResourcesStatus = 'complete';
    } else {
      vendorResourcesStatus = 'not started';
    }

    let otherResourcesStatus = '';
    if (vm.assessment.status.otherResourcesStatus !== 'No Other Resources Added') {
      otherResourcesStatus = 'complete';
    } else {
      otherResourcesStatus = 'not started';
    }
    if (
      departmentProceduresStatus === 'complete'
      && departmentResourceStatus === 'complete'
      && facilitiesStatus === 'complete'
      && itCoreProceduresStatus === 'complete'
      && (schematicStatus === 'complete' || !vm.assessment.includeSchematics)
      && (workstationStatus === 'complete' || !vm.assessment.includeSchematics)
      && (serverStatus === 'complete' || !vm.assessment.includeSchematics)
      && (emergencyPlansStatus === 'complete' || !vm.assessment.includeEmergencyPlan)
      && (pandemicPlansStatus === 'complete' || !vm.assessment.includePandemicPolicy)
      && successionPlanningStatus === 'complete'
      && (healthResourceStatus === 'complete' || !vm.assessment.includeKeyContacts)
      && (vendorResourcesStatus === 'complete' || !vm.assessment.includeKeyContacts)
      && (otherResourcesStatus === 'complete' || !vm.assessment.includeKeyContacts)
    ) {
      vm.riskManagementStatus = 'complete';
    } else if (
      departmentProceduresStatus === 'not started'
      && departmentResourceStatus === 'not started'
      && facilitiesStatus === 'not started'
      && itCoreProceduresStatus === 'not started'
      && schematicStatus === 'not started'
      && workstationStatus === 'not started'
      && serverStatus === 'not started'
      && emergencyPlansStatus === 'not started'
      && pandemicPlansStatus === 'not started'
      && successionPlanningStatus === 'not started'
      && healthResourceStatus === 'not started'
      && vendorResourcesStatus === 'not started'
      && otherResourcesStatus === 'not started'
    ) {
      vm.riskManagementStatus = 'not started';
    } else {
      vm.riskManagementStatus = 'in progress';
    }

    const hardwareAndSchematicsText = vm.assessment.includeSchematics
      ? `${vm.assessment.status.schematicStatus}<br>
      ${vm.assessment.status.workstationStatus}<br>
      ${vm.assessment.status.serverStatus}<br>`
      : '';

    const emergencyPlanText = vm.assessment.includeEmergencyPlan
    /* eslint-disable-line */
      ? `${vm.assessment.status.emergencyPlansStatus}<br>`
      /* eslint-disable-line */
      : '';

    const pandemicPolicyText = vm.assessment.includePandemicPolicy
    /* eslint-disable-line */
      ? `${vm.assessment.status.pandemicPlansStatus}<br>`
      /* eslint-disable-line */
      : '';

    const keyContactsText = vm.assessment.includeKeyContacts
      ? `${vm.assessment.status.healthResourceStatus}<br>
      ${vm.assessment.status.vendorResourcesStatus}<br>
      ${vm.assessment.status.otherResourcesStatus}<br>`
      : '';

    vm.riskManagementStatusText = `${vm.assessment.status.departmentProceduresStatus}<br>
      ${vm.assessment.status.departmentResourceStatus}<br>
      ${vm.assessment.status.facilitiesStatus}<br>
      ${vm.assessment.status.itCoreProceduresStatus}<br>
      ${hardwareAndSchematicsText}
      ${emergencyPlanText}
      ${pandemicPolicyText}
      ${vm.assessment.status.successionPlanningStatus}<br>
      ${keyContactsText}
    `;
  }

  function _handleExpandAssessment() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleEditAssessment($event) {
    bcpDataService.getAssessment(vm.assessment.assessmentId).then((getAssessmentResponse) => {
      bcpDataService.getSettings().then((getSettingsResponse) => {
        const result = getAssessmentResponse.data;
        ssDialogService.dialogs.bcp.addAssessmentDialog = ssDialogService.alert(
          addAssessmentDialog.getOptions($event, {
            assessment: result,
            settings: getSettingsResponse.data.result.customerConfiguration,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.bcp.addAssessmentDialog);
      });
    });
  }

  function _handleAttachDocument($event) {
    ssDialogService.dialogs.bcp.editDocumentAttachmentDialog = ssDialogService.alert(
      bcpEditAssessmentDocumentDialog.getOptions($event, {
        assessment: vm.assessment,
        document: {
          assessmentDocumentId: 0,
          deletable: true,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editDocumentAttachmentDialog);
  }

  function _handleDownloadAllDocuments() {
    loaderService.showViewLoader = true;
    bcpDataService.downloadAllAssessmentDocuments(vm.assessment.assessmentId).then((response) => {
      _handleDownload(response);
    });
  }

  function _handleDownload(response) {
    alerts.success('The file download will start momentarily.');
    const contentDisposition = response.headers('Content-Disposition');

    if (!R.isNil(contentDisposition)) {
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      vm.downloadName = matches && matches.length > 1 ? matches[1] : null;
      vm.downloadName = vm.downloadName.split('"').join('');
    }

    const blob = new Blob(
      [response.data],
      { type: 'application/x-zip-compressed', }
    );

    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, vm.downloadName);
    } else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.setAttribute('type', 'hidden');

      anchor.href = URL.createObjectURL(blob);
      anchor.download = vm.downloadName;
      anchor.target = '_self';
      anchor.click();
    }

    loaderService.showViewLoader = false;
  }

  function _handleGenerateReport($event) {
    bcpDataService.getSettings().then((getSettingsResponse) => {
      ssDialogService.dialogs.bcp.generateFullReportDialog = ssDialogService.alert(
        generateFullReportDialog.getOptions($event, {
          assessment: vm.assessment,
          settings: getSettingsResponse.data.result.customerConfiguration,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.generateFullReportDialog);
    });
  }

  function _handleBoardApprove($event) {
    if (!vm.assessment.canBoardApprove) {
      alerts.error(
        'Cannot Approve Plan. Please approve / prioritize all processes and save latest '
        + 'finalized document before attempting board approval.'
      );
    } else {
      orgDataService.getSelectableUsers().then((response) => {
        ssDialogService.dialogs.bcp.boardApproveDialog = ssDialogService.alert(
          bcpBoardApproveDialog.getOptions($event, {
            assessmentId: vm.assessment.assessmentId,
            assessmentName: vm.assessment.name,
            includePandemicPolicy: vm.assessment.includePandemicPolicy,
            includeEmergencyPlan: vm.assessment.includeEmergencyPlan,
            includeKeyContacts: vm.assessment.includeKeyContacts,
            includeSchematics: vm.assessment.includeSchematics,
            isNavantaUser: vm.isNavantaUser,
            users: response.data.result,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.bcp.boardApproveDialog);
      });
    }
  }

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.deleteAssessmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Plan?',
        message: `Are you sure you want to delete Plan "${vm.assessment.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.deleteAssessmentConfirmDialog);
  }

  function _handleConfirmDelete() {
    return bcpDataService.deleteAssessment(vm.assessment.assessmentId)
      .then(() => {
        alerts.success('The Plan has been deleted successfully.');
        $rootScope.$broadcast('refreshBCPAssessments');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Plan.');
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.deleteAssessmentConfirmDialog);
  }

  function _setDocumentRegenerateFlag() {
    if (vm.assessment.documentId > 0) {
      vm.assessment.regenerateDocument = true;
    }
  }

  function _refreshAssessmentDocuments() {
    loaderService.showViewLoader = true;
    return bcpDataService.getAssessmentDocumentsByAssessment(vm.assessment.assessmentId).then((response) => {
      vm.assessment.assessmentDocuments = response.data.result;
      vm.documentsLoaded = true;
      loaderService.showViewLoader = false;
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }
}

IncompleteAssessmentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'orgDataService',
  'bcpDataService',
  'loaderService',
  'addAssessmentDialog',
  'bcpBoardApproveDialog',
  'bcpEditAssessmentDocumentDialog',
  'confirmDialog',
  'generateFullReportDialog',
  'ssDialogService',
  'userService'
];
